module.exports = __webpack_public_path__ + "img/mgh-nihonbashi-premier-sp.2cc3c0a0.jpg";